<template>
  <div class="toolPage">
    <div class="breadcrumb_one flex-rowl">
      <div class="breadcrumb_item">圭基MODEL <span>(Beta 1.1)</span></div>
      <div class="breadcrumb_input_list flex-rowc">
        <div class="breadcrumb_input_item flex-rowc active">
          <i class="iconfont icon-caidan_jixiaohuaxiang"></i>
          <p>基础参数&产品穿戴合成</p>
        </div>
        <span></span>
        <div class="breadcrumb_input_item flex-rowc">
          <i class="iconfont icon-caidan_jixiaohuaxiang"></i>
          <p>穿戴效果细节调整</p>
        </div>
        <span></span>
        <div class="breadcrumb_input_item flex-rowc">
          <i class="iconfont icon-caidan_jixiaohuaxiang"></i>
          <p>动作姿势、背景及滤镜</p>
        </div>
        <div class="return" @click="handleReturn">
          <el-image
            style="width: 36px; height: 36px"
            :src="require('@/assets/images/tool_edit_return.png')"
          ></el-image>
        </div>
      </div>
    </div>
    <div class="container_wrap flex-between">
      <div class="left_wrap">
        <div class="collapse_wrap">
          <div class="collapse_item one" :class="{ active: isModelParams }">
            <div
              class="collapse_item_tit flex-between"
              @click="handleChangeTit(1)"
            >
              <div class="flex-rowl">
                <div class="icon">
                  <el-image
                    style="width: 76px; height: 76px"
                    :src="require('@/assets/images/tool_edit_box01.png')"
                  ></el-image>
                </div>
                <p>模特基础参数管理</p>
              </div>
              <div class="arr"><i class="iconfont icon-arrow1"></i></div>
            </div>
            <div class="collapse_item_content" v-if="isModelParams">
              <div class="select_wrap flex-rowl">
                <div class="select_item">
                  <div class="select_box">
                    <el-select
                      v-model="modelParams.skinTone"
                      placeholder="人种肤色"
                    >
                      <el-option
                        v-for="item in skinTone"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="select_item">
                  <div class="select_box">
                    <el-select
                      v-model="modelParams.genderExpression"
                      placeholder="性别气质"
                    >
                      <el-option
                        v-for="item in genderExpression"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="select_item">
                  <div class="select_box">
                    <el-select
                      v-model="modelParams.agePreference"
                      placeholder="年龄偏向"
                    >
                      <el-option
                        v-for="item in agePreference"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="select_item">
                  <div class="select_box">
                    <el-select
                      v-model="modelParams.typePreference"
                      placeholder="体型偏向"
                    >
                      <el-option
                        v-for="item in typePreference"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="select_item">
                  <div class="select_box">
                    <el-select
                      v-model="modelParams.visualHeight"
                      placeholder="视觉身高"
                    >
                      <el-option
                        v-for="item in visualHeight"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="select_item">
                  <div class="select_box">
                    <el-select
                      v-model="modelParams.presetSelector"
                      placeholder="选择预设方案"
                    >
                      <el-option
                        v-for="item in presetSelector"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="content_wrap"></div>
              <div class="custom_btn flex-rowc">
                执行预览 <i class="iconfont icon-yuyinjiantou"></i>
              </div>
            </div>
          </div>
          <div
            class="collapse_item"
            :class="{ active: isFacialMakeupParameter }"
          >
            <div
              class="collapse_item_tit flex-between"
              @click="handleChangeTit(2)"
            >
              <div class="flex-rowl">
                <div class="icon">
                  <el-image
                    style="width: 76px; height: 76px"
                    :src="require('@/assets/images/tool_edit_box02.png')"
                  ></el-image>
                </div>
                <p>五官妆容参数管理</p>
              </div>
              <div class="arr"><i class="iconfont icon-arrow1"></i></div>
            </div>
            <div class="collapse_item_content"></div>
          </div>
        </div>
      </div>
      <div class="center_wrap">
        <div class="operation_wrap flex-rowr">
          <div class="operation_left">
            <div class="icon student flex-rowl" @click="handleTaost">
              <i class="iconfont icon-student"></i>
            </div>
            <div class="icon student flex-rowl">
              <i class="iconfont icon-paizhao" @click="handleTaost"></i>
            </div>
          </div>
          <div class="operation_right flex-rowr">
            <div class="icon rest flex-rowl" @click="handleTaost">
              <i class="iconfont icon-shuaxin"></i>
            </div>
            <div class="icon lessen flex-rowl" @click="handleTaost">
              <i class="iconfont icon-suoxiao"></i>
            </div>
            <div class="icon enlarg flex-rowl" @click="handleTaost">
              <i class="iconfont icon-fangda2"></i>
            </div>
            <div class="icon data flex-rowl" @click="handleTaost">
              <i class="iconfont icon-yunshujuku"></i>
            </div>
          </div>
        </div>
        <div class="main flex-rowc">
          <!-- <el-image
            style="width: 307px"
            :src="require('@/assets/images/tool_edit_img.png')"
            fit="cover"
          ></el-image> -->
          <img :src="require('@/assets/images/tool_edit_img.png')" alt="" srcset="">
        </div>
      </div>
      <div class="right_wrap">
        <div class="tit flex-rowl">
          <div class="icon">
            <el-image
              style="width: 76px; height: 76px"
              :src="require('@/assets/images/tool_edit_box03.png')"
            ></el-image>
          </div>
          <p>产品穿戴设置</p>
        </div>
        <div class="content_wrap">
          <div class="content_item flex-rowl">
            <div class="content_box flex-rowl">
              <div class="pic">
                <el-image
                  style="width: 45px; height: 45px"
                  :src="require('@/assets/images/tool_edit_box03_01.png')"
                ></el-image>
              </div>
            </div>
            <div class="add flex-rowc">+</div>
          </div>
          <div class="content_item flex-rowl">
            <div class="content_box flex-rowl">
              <div class="pic">
                <el-image
                  style="width: 45px; height: 45px"
                  :src="require('@/assets/images/tool_edit_box03_02.png')"
                ></el-image>
              </div>
            </div>
            <div class="add flex-rowc">+</div>
          </div>
          <div class="content_item flex-rowl">
            <div class="content_box flex-rowl">
              <div class="pic">
                <el-image
                  style="width: 45px; height: 45px"
                  :src="require('@/assets/images/tool_edit_box03_03.png')"
                ></el-image>
              </div>
            </div>
            <div class="add flex-rowc">+</div>
          </div>
          <div class="content_item flex-rowl">
            <div class="content_box flex-rowl">
              <div class="pic">
                <el-image
                  style="width: 45px; height: 45px"
                  :src="require('@/assets/images/tool_edit_box03_04.png')"
                ></el-image>
              </div>
            </div>
            <div class="add flex-rowc">+</div>
          </div>
          <div class="content_item flex-rowl">
            <div class="content_box flex-rowl">
              <div class="pic">
                <el-image
                  style="width: 45px; height: 45px"
                  :src="require('@/assets/images/tool_edit_box03_05.png')"
                ></el-image>
              </div>
            </div>
            <div class="add flex-rowc">+</div>
          </div>
        </div>
        <div class="footer_btn flex-rowc">
          <div class="custom_btn flex-rowc">
            执行预览 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "toolEdit",
  data() {
    return {
      activeNames: "1",
      skinTone: [
        { value: "1", text: "浅肤色" },
        { value: "2", text: "中等肤色" },
      ], // 人种肤色
      genderExpression: [], // 性别气质
      agePreference: [], // 年龄偏好
      typePreference: [], // 体型偏向
      visualHeight: [], // 视觉身高
      presetSelector: [], // 选择预设方案

      modelParams: {
        genderExpression: "",
        agePreference: "",
        typePreference: "",
        visualHeight: "",
        presetSelector: "",
      },
      isModelParams: true,
      isFacialMakeupParameter: false,
    };
  },
  methods: {
    handleChangeTit(type) {
      if (type == 1) {
        this.isModelParams = !this.isModelParams;
      } else if (type == 2) {
        this.isFacialMakeupParameter = !this.isFacialMakeupParameter;
      }
    },
    handleReturn() {
      this.$router.back();
    },
    handleTaost() {},
  },
};
</script>

<style lang="less" scoped>
.toolPage {
  padding: 128px 60px 0;
  // min-height: 100vh;
  box-sizing: border-box;
  @media screen and (min-width: 1510px) {
    /* 在小屏幕下的样式 */
    .breadcrumb_one {
      .breadcrumb_input_list {
        .breadcrumb_input_item {
          width: 300px !important;
          height: 54px !important;
          .iconfont {
            font-size: 20px !important;
          }
          p {
            font-size: 16px !important;
          }
        }
      }
    }
  }
  .breadcrumb_one {
    font-size: 30px;
    color: #000000;
    height: 120px;
    margin-bottom: 10px;
    span {
      font-size: 16px;
      color: #666666;
    }
    .breadcrumb_input_list {
      flex: 1;
      // margin-left: 42px;
      .breadcrumb_input_item {
        background: url(../../assets/images/tool_edit_input.png) no-repeat
          center;
        background-size: cover;
        width: 378px;
        height: 68px;
        font-size: 20px;
        color: #969696;
        position: relative;
        &::after {
          display: inline-block;
          content: "";
          width: 30px;
          height: 6px;
          background: #ebebeb;
          position: absolute;
          left: 30px;
          bottom: -11px;
        }
        .iconfont {
          position: absolute;
          font-size: 24px;
          left: 32px;
          top: 50%;
          transform: translateY(-50%);
        }
        &.active {
          color: #333333;
          .iconfont {
            color: #f50630;
          }
          &::after {
            background: #f50630;
          }
        }
      }
      span {
        width: 20px;
        height: 10px;
        border-radius: 5px;
        background: #666666;
        margin: 0 11px;
      }
      .return {
        margin-left: 36px;
        cursor: pointer;
      }
    }
  }
  .container_wrap {
    // height: calc(100vh - 270px);
    align-items: flex-start;
    .left_wrap {
      flex: 1;
      // height: 100%;
      // overflow-y: scroll;
      padding: 10px;
      box-sizing: border-box;
      .collapse_wrap {
        .collapse_item {
          box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);
          border-radius: 5px;
          overflow: hidden;
          padding: 5px;
          box-sizing: border-box;
          .collapse_item_tit {
            padding: 5px 30px 5px 5px;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 18px;
            color: #333333;
            height: 50px;
            overflow: hidden;
            p {
              margin-left: 15px;
              position: relative;
            }
          }
          &.active {
            .collapse_item_tit {
              height: auto;
              p {
                &::after {
                  position: absolute;
                  width: 50%;
                  height: 6px;
                  background: #666666;
                  display: inline-block;
                  content: "";
                  left: 0;
                  bottom: -14px;
                }
              }
              .iconfont {
                transform: rotate(-180deg);
              }
            }
          }
          &:nth-child(2) {
            margin: 30px 0;
          }
          .custom_btn {
            margin: 31px auto 40px;
          }
          &.one {
            .collapse_item_content {
              padding: 0 20px;
              box-sizing: border-box;
              .select_wrap {
                margin: 10px auto 30px;
                flex-wrap: wrap;
                .select_item {
                  position: relative;
                  padding-left: 15px;
                  width: calc((100% - 60px) / 2);
                  margin-bottom: 20px;
                  &::before {
                    width: 6px;
                    height: 20px;
                    background: #666666;
                    display: inline-block;
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                  }
                  .select_box {
                    border-bottom: 1px solid #c3c3c3;
                    /deep/.el-input__inner {
                      padding: 0;
                      border: none;
                    }
                  }
                  &:nth-child(2n-1) {
                    margin-right: 30px;
                  }
                  &:last-child {
                    width: 100%;
                  }
                }
              }
              .content_wrap {
                min-height: 160px;
                background: #f5f5f5;
                border-radius: 15px;
                font-size: 14px;
                color: #333333;
              }
            }
          }
        }
      }
    }
    .center_wrap {
      margin: 0 10px;
      flex: 2;
      height: 100%;
      border: 2px solid #e7e7e7;
      background: #fff;
      position: relative;
      box-sizing: border-box;
      &::before {
        position: absolute;
        content: "";
        left: 50%;
        transform: translateX(-50%);
        top: -6px;
        width: 60px;
        height: 6px;
        background: #f50630;
      }
      .operation_wrap {
        position: relative;
        padding: 20px 20px 10px;
        box-sizing: border-box;
        .operation_left {
          position: absolute;
          top: 20px;
          left: 17px;
          .student {
            margin-bottom: 17px;
          }
        }
        .operation_right {
          .icon {
            margin-right: 18px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .iconfont {
          font-size: 30px;
        }
      }
      .main {
        // height: calc(100vh - 350px);
        // overflow-y: scroll;
        // position: relative;
        img {
          width: 307px;
          // position: absolute;
          // top: 0;
        }
      }
    }
    .right_wrap {
      flex: 1;
      
      // height: 100%;
      box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      padding: 10px;
      box-sizing: border-box;
      position: relative;
      .tit {
        font-size: 18px;
        color: #333333;
        p {
          margin-left: 15px;
          position: relative;
          &::after {
            position: absolute;
            width: 70%;
            height: 6px;
            background: #666666;
            display: inline-block;
            content: "";
            left: 0;
            bottom: -14px;
          }
        }
      }
      .content_wrap {
        margin-top: 10px;
        height: 730px;
        //  height: calc(100vh - 470px);
        overflow-y: scroll;
        padding-bottom: 120px;
        box-sizing: border-box;
        .content_item {
          padding: 20px 10px 15px;
          border-bottom: 1px solid #c3c3c3;
          box-sizing: border-box;
          position: relative;
          margin-left: 15px;
          margin: 0 70px 0 38px;
          align-items: flex-start;
          flex-flow: wrap;
          &::before {
            position: absolute;
            content: "";
            left: -10px;
            top: 20px;
            width: 6px;
            height: 30px;
            background: #666666;
          }
          .content_box {
            align-items: flex-start;
            flex-flow: wrap;
          }
          .add {
            width: 80px;
            height: 80px;
            border: 1px dashed #c8c8c8;
            font-size: 60px;
            color: #c8c8c8;
            border-radius: 10px;
            cursor: pointer;
            margin-left: 25px;
          }
        }
      }
      .footer_btn {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100px;
        border-top-left-radius: 70px;
        border-top-right-radius: 70px;
        background: #fff;
        box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);
      }
    }
    .custom_btn {
      width: 160px;
      height: 40px;
      border-radius: 45px;
      background: #373737;
      font-size: 16px;
      color: #fff;
      position: relative;
      cursor: pointer;
      margin: auto;
      .iconfont {
        position: absolute;
        transform: rotate(-90deg);
        right: 10px;
      }
    }
  }
}
</style>